import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from "@angular/router";
import { GlobalsService } from '@services/globals.service';
import { Segment } from '@app/models/cart/segment.model';

/**
 * Componente que muestra un banner de información de vuelo.
 */
@Component({
    selector: 'am-flight-info-banner',
    templateUrl: './am-flight-info-banner.component.html',
    styleUrls: ['./am-flight-info-banner.component.scss'],
    standalone: false
})
export class AmFlightInfoBannerComponent implements OnInit {
 /**
   * Tipo de error principal que se mostrará en el banner.
   *
   * @type {string}
   */
 @Input() typeError: string;

 /**
  * Tipo de error secundario que se mostrará en el banner.
  * Este valor se calcula dinámicamente en función del operador del vuelo seleccionado.
  *
  * @type {string}
  * @default ''
  */
 @Input() typeError2: string = '';

 /**
  * Segmento de vuelo seleccionado.
  * Se obtiene del servicio `GlobalsService` y se utiliza para calcular el tipo de error secundario.
  *
  * @type {Segment}
  */
 selectedTrip: Segment;

 /**
  * EventEmitter que se utiliza para emitir un evento cuando el usuario realiza la acción "next".
  * El evento emite el tipo de error principal (`typeError`).
  *
  * @type {EventEmitter<any>}
  */
 @Output() next: EventEmitter<any> = new EventEmitter<any>();
  constructor(private _router: Router, private global: GlobalsService,) {
    this.selectedTrip = this.global.getSelectedTrip();
  }

  ngOnInit(): void {
    if (this.typeError == 'flightInfo.flightNotOperatedByAm') {
      this.typeError2 = 'flightInfo.' + this.selectedTrip.operatingCarrier
    }
  }
    /**
   * Método que se ejecuta cuando el usuario realiza la acción "next".
   * Emite un evento con el tipo de error principal (`typeError`) a través del `EventEmitter`.
   *
   * @return {void} No retorna ningún valor.
   */
  onNext() {
    this.next.emit(this.typeError);
  }
    /**
   * Método que se ejecuta cuando el usuario hace clic en el banner.
   * Navega a la página de selección de pasajeros (`/choose-passagers`).
   *
   * @return {void} No retorna ningún valor.
   */
  onClick() {
    this._router.navigate(['/choose-passagers'])
  }

}
